import React from 'react';
import { connect } from 'react-redux';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { selectNameByVariableId } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectOpenByDefaultOrWhenWindowed, selectThumbnailAssetUrlById } from './_redux';
import { SvgInputControlAccordion } from './partials/SvgInputControlAccordion';
import { SvgInputControlMobile } from './partials/SvgInputControlMobile';

const _SvgInputControl = (props: Props) => {
    const isMobile = useMobile();
    if (isMobile) {
        return <SvgInputControlMobile {...props} />;
    } else {
        return <SvgInputControlAccordion {...props} />;
    }
};

type Props = {
    variableIds: string[];
    name: string;
    selectedAssetUrl: string;
    openByDefault: boolean;
    isContentFirst: boolean;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    name: selectNameByVariableId(state, ownProps.variableIds[0])!,
    selectedAssetUrl: selectThumbnailAssetUrlById(state, ownProps.variableIds[0])!,
    openByDefault: selectOpenByDefaultOrWhenWindowed(state, ownProps.variableIds[0])!,
    isContentFirst: state.scene.options?.contentFirst ?? false
});

export const SvgInputControl = connect(
    mapStateToProps
)(_SvgInputControl);